<template>
	<div class='notification_button'>
		<div
			class='notification_button__overlay'
			:class='{ "notification_button__overlay--show" : showMenu}'
			@click='setShowMenu(false)'
		></div>		
		<div
			class='notification_button__menu_group'
			:class='{ "notification_button__menu_group--show" : showMenu}'
		>
			<div class='notification_button__menu'>				

				<div class='notification_button__menu__empty'>
					<span class="pt-2">{{emojis[emojiIndex % 6]}}</span>
                    <span style="font-size: 1rem;">
                        {{ $t('gifts_verify_email') }} {{ $t('gifts_verify_email_2') }}	
						<a :href="`https://${ $store.state.meta.lang }.idcgames.com/${ $t('gifts_info_account') }`">{{ $t('gifts_here') }}</a>.					 
                    </span>					
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		name: 'NotificationForm',
		data () {
			return {				
				notifications: [],

				showMenu: false,
				shake: false,
				emojis: ['😢', '🤷', '😘', '😒', '😔', '💩'],
				emojiIndex: Math.round(Math.random()*5),				
			}
		},
		computed: {	             
		},
		methods: {			
			setShowMenu (val) {

				this.showMenu = val

				if(!val) {
					setTimeout(() => {
						this.emojiIndex++
					}, 200)
				}                
				
			},			
		},
		created () {
            this.setShowMenu(true);
		},
		watch: {
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/scss/variables.scss';

	@keyframes shake {
		0% {
			position: relative;
			left: 0;
		}
		25% {
			position: relative;
			left: -1rem;
		}
		75% {
			position: relative;
			left: 1rem;
		}
		100% {
			left: 0rem;
		}
	}

	.notification_button {
		position: relative;

		@at-root #{&}__overlay {
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			position: fixed;
			z-index: 5;
			pointer-events: none;

			@at-root #{&}--show {
				pointer-events: all;
			}
		}

		@at-root #{&}__menu_group {
			position: relative;
			top: -3rem;

			pointer-events: none;
			opacity: 0;
			transition: opacity 0.2s, top 0.2s;

			@at-root #{&}--show {
				pointer-events: all;
				opacity: 1;
				top: 0;
			}
		}

		@at-root #{&}__triangle {
			width: 1rem;
			height: 1rem;
			background-color: #fafafa;
			transform: rotate(45deg);
			position: absolute;
			top: 40px;
			border-radius: 0.125rem 0 0 0;
			border: 1.5px solid $color__gray--darkest;
			left: calc(50% - 1rem /2);
			clip-path: polygon(0 0, 100% 0%, 0 100%);
			z-index: 8;
		}
		@at-root #{&}__menu {
			right: 10px;
			background: #13181d;
			position: absolute;
			top: 1px;
			width: 20rem;
			border-radius: 0.25rem;
			border: 1.5px solid rgba(0, 255, 126, 0.25);
			box-shadow: 0 0.25rem 1rem rgba(#000, 0.125);
			min-height: 5.5rem;
			max-height: 15rem;
			overflow-y: auto;
			z-index: 7;

			@at-root #{&}__empty {
				background-color: #13181d;
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 2rem;
				height: 8rem;
				justify-content: center;
				font-size: 1rem;
				user-select: none;
				cursor: default;
				transition: none;
				color: $color__gray--darkest;

				span {
					font-size: 2rem;
					color: $color__gray--darker;					
				}
			}

			@at-root #{&}__item {
				@at-root #{&}--no_border:last-child {
					border: none;
				}

				padding: 0.5rem;
				border-bottom: thin solid rgba(0, 255, 126, 0.25);
				cursor: default;

				transition: background-color 0.2s;

				@at-root #{&}--uninteracted {
					background-color: rgba(13, 71, 161, 0.1);
					border-bottom-color: rgba(0, 255, 126, 0.25);

					&:hover {
						background-color: rgba(13, 71, 161, 0.2);
					}
				}
				
				@at-root #{&}__link {
					font-weight: 400;
					cursor: pointer;
					color: #00ff7f;
				}

				@at-root #{&}__content {
					font-style: italic;
				}

				@at-root #{&}__header {
					display: flex;
					justify-content: space-between;
					font-size: 0.9rem;

					@at-root #{&}__close {
						height: 0.9rem;
						width: 0.9rem;
						cursor: pointer;
						display: inline-flex;
						border-radius: 100%;
						margin-left: 0.25rem;
						align-items: center;
						justify-content: center;
						padding: 0;
						color: #00ff7f;
						position: relative;
						top: 0.3rem;
						line-height: 1;
						transition: all 0.2s;
						font-size: 1.5rem;

						&:hover {
							filter: brightness(0.9);
						}
					}
				}
			}
		}

		@at-root #{&}__button {
			position: relative;
			height: 2.5rem;
			width: 2.5rem;
			transition: border 0.4s, padding 0.4s;

			@at-root #{&}--shake {
				animation-name: shake;
				animation-iteration-count: 4;
				animation-duration: 0.25s;
				animation-timing-function: ease-in-out;
			}

			@at-root #{&}__icon {
				font-size: 1.5rem;
				position: relative;
				top: -0.125rem;
			}

			@at-root #{&}__count {
				position: absolute;
				background-color: $color__blue--primary;
				line-height: 1;
				margin-left: 0.25rem;
				color: #fff;
				border-radius: 100%;
				height: 1rem;
				width: 1rem;
				display: inline-flex;
				align-items: center;
				padding: 0.75rem;
				font-size: 0.9rem;
				justify-content: center;
				left: 0.8rem;
				top: -0.2rem;

				transition: all 0.2s;

				@at-root #{&}--none {
					opacity: 0;
				}
				@at-root #{&}--two_figure {
					font-size: 0.8rem;
				}
				@at-root #{&}--three_figure {
					font-size: 0.7rem;
				}
			}
		}
	}

	@media (max-width: 600px) {
		.notification_button__menu_group {
			left: calc(3.5rem - 100vw);
			width: calc(100vw - 0.25rem);
		}
		.notification_button__menu {
			left: unset;
		}
	}

	@media (max-width: 870px) {
		//Because the notification button is
		//actually a child of the hamburger menu
		//it 'pops up' when the overlay is showing
		//so we cover it with its own overlay
		//hacky but it works...
		.notification_button__button::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			pointer-events: none;
			opacity: 0;
			width: 100%;
			border-radius: 0.25rem;
			height: 100%;
			background-color: hsla(215, 13%, 25%, 0.5);
			transition: all 0.4s;
		}
		.header__group--show .notification_button {
			cursor: default;
			pointer-events: none;

			@at-root #{&}__button {
				border: none;

				&::before {
					opacity: 1;
				}
			}
		}

		.notification_button {
			position: fixed;
			right: 0.5rem;
			width: 2.4rem;
			top: 0.5rem;
			border-radius: 0.25rem;

			@at-root #{&}__button {
				border: none;
			}

			@at-root #{&}__menu_group {
				left: calc(3.5rem - 100vw);
				width: calc(100vw - 0.25rem);
			}

			@at-root #{&}__menu {
				right: 0.5rem;

				@at-root #{&}__empty {
					font-weight: normal;
				}
			}
			
			@at-root #{&}__triangle {
				left: unset;
				right: 1.55rem;
			}
		}
	}
</style>
<style>
.navbar-badge {    
    position: absolute;
    left: 16px;
    top: -9px
}
</style>